<button
  id="event-filter-dropdown"
  class="filter-container"
  (click)="isOverlayOpen = !isOverlayOpen"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
>
  <ng-container
    *ngTemplateOutlet="bagde; context: { $implicit: computedSelectedEvent() }"
  ></ng-container>
  <sh-text class="event-date">
    {{ computedSelectedEvent()?.timestampFormatted }}
  </sh-text>
  <sh-icon icon="arrow-face-down-s"></sh-icon>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOverlayOpen"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  (overlayOutsideClick)="overlayOpenNext(false)"
  (overlayKeydown)="onOverlayKeydown($event)"
  (detach)="overlayOpenNext(false)"
>
  <div class="filter-overlay">
    <sh-tabs role="tablist">
      <sh-tab-item
        label="{{ 'cts.gantry.tab.allEvents' | translate }} ({{
          computedEvents()?.length ?? 0
        }})"
        [active]="activeTab === ALL_EVENTS_TAB"
        (click)="updateActiveTab(ALL_EVENTS_TAB)"
        (keydown.enter)="updateActiveTab(ALL_EVENTS_TAB)"
      ></sh-tab-item>
      <sh-tab-item
        label="{{ 'cts.gantry.tab.errors' | translate }} ({{
          errorEvents()?.length ?? 0
        }})"
        [active]="activeTab === ERRORS_TAB"
        (click)="updateActiveTab(ERRORS_TAB)"
        (keydown.enter)="updateActiveTab(ERRORS_TAB)"
      ></sh-tab-item>
    </sh-tabs>

    @if (activeTab === ALL_EVENTS_TAB) {
      <ng-container
        *ngTemplateOutlet="
          eventList;
          context: { $implicit: { events: computedEvents() } }
        "
      >
      </ng-container>
    }

    @if (activeTab === ERRORS_TAB) {
      <ng-container
        *ngTemplateOutlet="
          errorEvents()?.length > 0 ? eventList : emptyStateEventsFailed;
          context: { $implicit: { events: errorEvents() } }
        "
      >
      </ng-container>
    }
  </div>
</ng-template>

<ng-template #eventList let-data>
  <div class="event-item-group">
    @for (event of data.events; track $index + '-' + event.timestamp) {
      <div>
        <button
          (click)="onItemClick(event)"
          class="event-item"
          [class.event-item--selected]="computedSelectedEvent() === event"
        >
          <ng-container
            *ngTemplateOutlet="bagde; context: { $implicit: event }"
          ></ng-container>

          <sh-text class="event-date">
            {{ event?.timestampFormatted }}
          </sh-text>
          <sh-text color="secondary">{{ event.typeDescription }}</sh-text>
        </button>
      </div>
    }
  </div>
</ng-template>

<ng-template #bagde let-event>
  @if (event && event.type !== UNKNOWN) {
    <sh-badge
      type="{{ ctsGantryInitEventStatusService.translate(event.type) }}"
    ></sh-badge>
  } @else {
    <sh-badge class="gray-badge" [label]="WHITE_SPACE"></sh-badge>
  }
</ng-template>

<ng-template #emptyStateEventsFailed>
  <div class="empty-state-container">
    <sh-empty-state
      label="{{ 'cts.gantry.noEventsFailed' | translate }}"
    ></sh-empty-state>
  </div>
</ng-template>
